var requireSvg = require.context('!raw-loader!svgo-loader?{"plugins":[{"removeTitle":true},{"cleanupIDs":false}]}!../images/', false, /\.svg$/);

export default function(name) {
  return requireSvg(`./${name}`);
}



// WEBPACK FOOTER //
// resources/assets/js/svg.js